@if (itemOptions()?.has("Z")) {
  <!-- Narrow layouts: the note under the description, "No Returns" stays in the corner. Wide: both bottom right, under the price and quantity. -->
  <div custom-cut-details narrow *renderInCartItemResultLayout="LayoutTargets.Summary">
    <span custom-cut-notice>* Subject to additional reel charge</span>
  </div>
  <div custom-cut-details wide *renderInCartItemResultLayout="LayoutTargets.Extended">
    <ideal-product-not-returnable-view [returnable]="false" />
    <span custom-cut-notice>* Subject to additional reel charge</span>
  </div>
}

<div item-extras *renderInCartItemResultLayout="LayoutTargets.Extended">
  <div>
    @if (pricingError()) {
      <ideal-error [error]="pricingError()" mode="button" />
    } @else {
      <ideal-item-price-view
        withLoadingSkeleton
        [isLoading]="pricingLoading()"
        class="big"
        [pricing]="cartItemPricingModel()"
        usePricePer="auto"
      />
    }
  </div>
  <div quantity (widthChange)="onQuantityWidthChange($event)">
    <ideal-cart-item-quantity-selector-view
      [(quantity)]="cartItemQuantity"
      [isUpdating]="isItemPending()"
      [pricing]="cartItemPrice()"
      [compact]="compactQuantity()"
    ></ideal-cart-item-quantity-selector-view>
  </div>
</div>
